'use client';

import { useEffect, useState } from 'react';

interface TypingEffectProps {
  strings: string[];
  speed?: number;
  deleteSpeed?: number;
  pause?: number;
  className?: string;
}

export default function TypingEffect({
  strings,
  speed = 80,
  deleteSpeed = 45,
  pause = 1800,
  className = '',
}: TypingEffectProps) {
  const [displayed, setDisplayed]   = useState('');
  const [strIndex, setStrIndex]     = useState(0);
  const [charIndex, setCharIndex]   = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isPaused, setIsPaused]     = useState(false);

  useEffect(() => {
    if (isPaused) {
      const t = setTimeout(() => {
        setIsPaused(false);
        setIsDeleting(true);
      }, pause);
      return () => clearTimeout(t);
    }

    const current = strings[strIndex];

    if (!isDeleting) {
      if (charIndex < current.length) {
        const t = setTimeout(() => {
          setDisplayed(current.slice(0, charIndex + 1));
          setCharIndex(c => c + 1);
        }, speed);
        return () => clearTimeout(t);
      } else {
        const t = setTimeout(() => {
          setIsPaused(true);
        }, 0);
        return () => clearTimeout(t);
      }
    } else {
      if (charIndex > 0) {
        const t = setTimeout(() => {
          setDisplayed(current.slice(0, charIndex - 1));
          setCharIndex(c => c - 1);
        }, deleteSpeed);
        return () => clearTimeout(t);
      } else {
        const t = setTimeout(() => {
          setIsDeleting(false);
          setStrIndex(i => (i + 1) % strings.length);
        }, 0);
        return () => clearTimeout(t);
      }
    }
  }, [charIndex, isDeleting, isPaused, strIndex, strings, speed, deleteSpeed, pause]);

  return (
    <span className={className}>
      {displayed}
      <span className="cursor-blink" aria-hidden="true" />
    </span>
  );
}